export class SuggestData {
  initialWord: string = ''
  value: string = ''
}
